import { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import { Elements, RecurlyProvider } from "@recurly/react-recurly";

import routes from "../../routes";
import useScrollToTop from "../../utils/useScrollToTop";
import Plans from "./Plans";
import TreatmentOptions from "./TreatmentOptions";
import Payment from "./Payment";
import Loading from "../Loading";
import ErrorBoundary from "./ErrorBoundry";
import Error from "./Error";
import RedirectFirstQuestion from "components/RedirectFirstQuestion";
import useAppContext from "components/AppContext";
import useUrlSlugContext from "components/UrlSlugContext";
import getAidFromCookie from "../../utils/getAidFromCookie";

const ClinicCheckout = () => {
  const [loading, setLoading] = useState(true);
  const { baseUrl } = useUrlSlugContext();
  const { newQuiz, profile } = useAppContext();

  const aid = getAidFromCookie(newQuiz, baseUrl);

  useScrollToTop();
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.recurly.com/v4/recurly.js";
    script.async = true;
    document.body.appendChild(script);
    script.onload = () => {
      setLoading(false);
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Redirect to beginning of quiz if the user does not have either a
  // previous seqAssessmentId (lapsed) or aid cookie.
  if (!loading && !(profile?.seqAssessmentId || aid)) {
    return <RedirectFirstQuestion />;
  }

  return (
    <Switch>
      <ErrorBoundary
        fallback={<Error onClick={() => window.location.reload()} />}
      >
        <Loading loading={loading}>
          <Route path={routes.clinicCheckoutPlans} component={Plans} />
          <Route
            path={routes.clinicCheckoutTreatmentOptions}
            component={TreatmentOptions}
          />
          <Route path={routes.clinicCheckoutPayment}>
            <RecurlyProvider
              publicKey={window.ww.recurlyPublicKey}
              required={["cvv"]}
            >
              <Elements>
                <Payment />
              </Elements>
            </RecurlyProvider>
          </Route>
        </Loading>
      </ErrorBoundary>
    </Switch>
  );
};

export default ClinicCheckout;
